const Burger = ({ title = 'Menu', ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 36 36" {...props}>
    <title>{title}</title>
    <path
      d="M16.35 33.654l16.97-16.97 2.122 2.12-16.97 16.971-2.122-2.121zM5.626 28.586L28.253 5.96l2.121 2.121L7.747 30.708l-2.121-2.122zM.558 17.862L17.528.892l2.122 2.12L2.68 19.984.557 17.862z"
      fillRule="evenodd"
      fill="currentColor"
    />
  </svg>
);

export default Burger;
